import React from 'react';
import ShareLink from 'components/ShareLink';
import SectionTitle from 'components/Utils/SectionTitle';
import Tag from 'components/Utils/Tag';
import { ReactComponent as Arrow } from 'images/icon/arrow_carousel.svg';
import { useWindowSize } from 'utils/useWindowSize';
import classnames from 'classnames';
import styles from './index.module.scss';

interface ISubInfo {
    setCopied: (bool: boolean) => void;
    tags?: ITag[];
    last?: string;
    next?: string;
    isArticle?: boolean;
    listName?: string;
    category?: string;
}

const SubInfo: React.FC<ISubInfo> = ({
    setCopied, tags, last, next, isArticle, listName, category
}): JSX.Element => {
    const onCopy = () => {
        setCopied(true);
    };
    const size = useWindowSize();
    return (
        <div className={classnames(styles.subInfo, { [styles.isArticle]: isArticle })}>
            <div className={styles.container}>
                <ShareLink setCopied={onCopy} className={styles.shareLink} isPreview={listName === 'preview'} />
                {isArticle && (
                    <>
                        {tags && tags?.length > 0 && <SectionTitle title="相關文章內容" size="md" className={styles.title} />}
                        <div className={styles.tagContainer}>
                            {
                                tags?.map(t => (
                                    <Tag text={t.name} className={styles.tag} key={`tag-${t.id}`} isAnchor />
                                ))
                            }
                        </div>
                        {listName !== 'preview' ? (
                            <div className={styles.menu}>
                                {last && listName
                                && (
                                    <a href={last} className={styles.last} title="移至上一篇文章">
                                        <Arrow />
                                        {`上一篇${size.width > 768 ? '文章' : ''}`}
                                    </a>
                                )}
                                <a href={`/${listName}`} className={styles.back} title={`回到「${category}」分類文章列表`}>
                                    回到列表
                                </a>
                                {next
                                && (
                                    <a href={next} className={styles.next} title="移至下一篇文章">
                                        {`下一篇${size.width > 768 ? '文章' : ''}`}
                                        <Arrow />
                                    </a>
                                )}
                            </div>
                        ) : (
                            <div className={styles.menu}>
                                <div className={styles.last}>
                                    {' '}
                                    <Arrow />
                                    {`上一篇${size.width > 768 ? '文章' : ''}`}
                                </div>
                                <div className={styles.back}>回到列表</div>
                                <div className={styles.next}>
                                    {' '}
                                    {`下一篇${size.width > 768 ? '文章' : ''}`}
                                    <Arrow />
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

SubInfo.defaultProps = {
    tags: [],
    last: '',
    next: '',
    listName: '',
    isArticle: false,
    category: ''
};

export default SubInfo;
